export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_785_PERFORMER': 'Performer',
    '_9852_MI2_SCORE__': 'MI2 Score %',
    '_9853_IMPROVEMENT_CATEGORY': 'Improvement Category',
    '_9854_OA_SCORE': 'OA Score',
    '_9855_MI2___SCORE': 'MI2 + Score',
    '_9856_SCORECARD_SCORE': 'Scorecard Score',
    '_9857_SCORECARD_CATEGORY': 'Scorecard Category',
    '_9858___CHANGED': '% Changed',
    '_9589_CURRENT': 'Current',
    '_9796_PREVIOUS': 'Previous',
    '_9865___NUM___POSITIONS': '{{num}} Positions',
    '_758_CURRENT_SCORECARD': 'Current Scorecard',
    '_756_PREVIOUS_SCORECARD': 'Previous Scorecard'
};
